PAGE_LIMIT = 6;
let countVisiblePosts = 9
const STEP_COUNT_POSTS = 6
const FILTER_ALL = 'filter_all'

let posts = [];

init();
mobileMenuInit();
mobileMenuItemClick();
submitSubscriber();


function init() {
    posts = document.getElementsByClassName('recent-card');
    const loadMoreButton = document.querySelector('#loadMore')

    // display a limited number of posts
    for(let i = 0; i < posts.length; i++ ) {
        if(i > countVisiblePosts - 1) {
            posts[i].style.display = 'none';
        }
    }

    setActiveTag(FILTER_ALL);

    const tagsWrap = document.getElementById('filters');
    const tags = tagsWrap?.getElementsByClassName('filter');

    if (tags) {
        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];

            tag.addEventListener('click', () => {
                selectTag(tag.id, tags);
            });
        }
    }


    function onClickMoreButton() {
        countVisiblePosts += STEP_COUNT_POSTS

        if (countVisiblePosts >= posts.length) {
            countVisiblePosts = posts.length
            if (loadMoreButton) {
                loadMoreButton.style.display = 'none'
            }
        }
        for (let i = 0; i < posts.length; i++ ) {
            if (i <= (countVisiblePosts - 1)) {
                posts[i].style.display = 'block';
            }
        }
    }

    if (posts.length <= countVisiblePosts && loadMoreButton) {
        loadMoreButton.style.display = 'none'
    }

    loadMoreButton?.addEventListener('click', onClickMoreButton)
}

function setActiveTag(id, tags) {
    if(tags) {
        for (let i = 0; i < tags.length; i++) {
            const tag = tags[i];
            tag.classList.remove('filter_active');
        }
    }

    const tag = document.getElementById(id);
    tag && tag.classList.add('filter_active');
}

function selectTag(id, tags) {
    const loadMoreButton = document.querySelector('#loadMore')
    setActiveTag(id, tags);

    if(posts) {
        for (let i = 0; i < posts.length; i++) {
            posts[i].style.display = 'none';

            const postTags = posts[i].getElementsByClassName('card-tag');
            const needToShow = includesFilter(postTags, id);
            if(needToShow) {
                loadMoreButton.style.display = 'none'
            }
            if (needToShow || id === FILTER_ALL) {
                posts[i].style.display = 'block';
            }
            if(id === FILTER_ALL && i > countVisiblePosts - 1) {
                posts[i].style.display = 'none';
                loadMoreButton.style.display = 'block'
            }
        }
    }
}

function includesFilter(tags, filter) {
    let result = false;

    for (let i = 0; i < tags.length; i++) {
        if (tags[i].dataset.filter === filter) {
            result = true;
            break;
        }
    }

    return result;
}


function mobileMenuInit() {
    const mobileSubLinks = document.querySelectorAll('.mobile-sub-links-wrap');
    mobileSubLinks.forEach(item => {
        item.style.display = "block";
    });

    const pageHeader = document.getElementById('gh-head-brand');
    const menuHamburger = document.getElementById('menuHamburger');
    const mobileMenuClose = document.getElementById('mobileMenuClose');
    const mobileMenuBg = document.getElementById('mobileMenuBg');
    const mainMenuLink = window.document.querySelectorAll('.main-mobile-menu-link');
    const widthWhenMobileMenuVisible = 720;
    const openedMenuClass = 'open-header';

    [mobileMenuClose, menuHamburger].forEach(button => {
        button.addEventListener('click', () => {
            pageHeader.classList.toggle(openedMenuClass);
            const bodyStyle = document.body.style;
            const mobileMenuBgStyle = mobileMenuBg.style;
            mainMenuLink.forEach((link) => {
                link.classList.remove('main-mobile-menu-link-open');
            });
            bodyStyle.overflow = bodyStyle.overflow === 'hidden' ? 'auto' : 'hidden';
            mobileMenuBgStyle.display = mobileMenuBgStyle.display === 'block' ? 'none' : 'block';
        });
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth > widthWhenMobileMenuVisible && pageHeader.classList.contains('open-header')) {
            mainMenuLink.forEach((link) => {
                link.classList.remove('main-mobile-menu-link-open');
            });
            pageHeader.classList.remove(openedMenuClass);
            document.body.style.overflow = 'auto';
            mobileMenuBg.style.display = 'none';
        }
    });
}

function mobileMenuItemClick() {
    const mainMenuLink = window.document.querySelectorAll('.main-mobile-menu-link');

    mainMenuLink.forEach((link) => {
        link.addEventListener('click', function (e) {
            link.classList.toggle('main-mobile-menu-link-open');
        });
    })
}

function submitSubscriber() {
    const form = document.querySelector('.subscribe-form-input')
    const input = document.querySelector('.gh-portal-input')

    if(!form || !input) return;

    form.addEventListener('submit', () => {
        setTimeout(() => {
            input.value = ''
        }, 1000)
    })
}
